<template lang="pug">
.views-container
  gb-side-menu
  .loading-area(v-if="fetchLoading")
    vue-loading(
      type='spin'
      color="#F7CA18"
      :size="{ width: '60px', height: '60px' }"
    )
  .content-area(v-else)
    div(style="display:flex;justify-content:space-between")
      h3 園児詳細
      gb-button(@clicked="toNote").effect ノート
    .edit-card(v-for="detail in details")
      .col-group
        div.flex
          h6.child-title 園児氏名（カナ）
          h4.child-detail {{ detail.family_name }} {{ detail.given_name }} （{{ detail.family_name_kana }} {{detail.given_name_kana}}）
        div.flex
          h6.child-title クラス名
          h4.child-detail {{detail.class_name}}
        div.flex
          h6.child-title 保護者名（カナ）
          h4.child-detail {{ fatherName }} （{{ fatherNameKana }}）
        div.flex
          h6.child-title 住所
          h5.child-detail {{ homeAddress }}
        div.flex
          h6.child-title メールアドレス
          h4.child-detail {{ detail.email }}
        div.flex
          h6.child-title 生年月日
          h4.child-detail {{ detail.birthday }}
        .edit-btn
          gb-button.primary(@clicked="back") 戻る
</template>

<script>
import util from '@/api/util'
import { VueLoading } from 'vue-loading-template'
import LocalDataUtil from '@/util/LocalDataUtil.js'
import moment from 'moment'

import GbSideMenu from '@/components/organisms/GbSideMenu.vue'
import GbButton from '@/components/atoms/GbButton.vue'

export default {
  components: {
    VueLoading,
    GbSideMenu,
    GbButton
  },
  data () {
    return {
      fetchLoading: true,
      details: [],
      detailsInfo: [],
      homeAddress: null,
      fatherName: null,
      fatherNameKana: null
    }
  },
  beforeMount: async function () {
    const isMaintenance = (await util.checkMaintenance({type: 'admin'})).data.data.is_maintenance
    if (isMaintenance) {
      this.$swal.fire({
        html: `現在メンテナンス中です`
      }).then(() => {
        this.$router.push({ name: 'Maintenance' })
      })
    } else {
      util.createMethod('COG', 'checkSessionExpired', null)
        .then(response => {
          if (response) {
            this.$router.push({ name: 'SignIn' })
          } else {
            this.fetchChildInfo()
            this.fetchChildDetailInfo()
          }
        })
    }
  },
  methods: {
    async fetchChildInfo () {
      const date = moment(Date()).format('YYYY-MM-DD')
      const CCS_REQUEST_VALUE = {
        session: LocalDataUtil.getCcsSession(),
        child_id: this.$route.params.childId,
        date: date
      }
      try {
        const Response = (await util.createMethod('CCS', 'ccsFetchChildInfo', CCS_REQUEST_VALUE, this.$route.params.nurseryCode)).data.data
        this.details = Response
        this.fetchLoading = false
      } catch (error) {
        let dialog
        if (error.data.error) dialog = error.data.error
        else dialog = `エラーが発生しました<br>時間をおいてもう一度お試しください`
        if (error.data.error) {
          this.$swal.fire({
            text: `${dialog}`
          }).then(() => {
            this.fetchLoading = false
          })
        }
      }
    },
    async fetchChildDetailInfo () {
      const CCS_REQUEST_VALUE = {
        session: LocalDataUtil.getCcsSession(),
        child_id: this.$route.params.childId
      }
      try {
        const Response = (await util.createMethod('CCS', 'ccsFetchChildDetailInfo', CCS_REQUEST_VALUE, this.$route.params.nurseryCode)).data.data
        this.detailsInfo = Response
        this.detailsInfo.forEach(element => {
          this.homeAddress = element.home_address
          this.fatherName = element.father_name
          this.fatherNameKana = element.father_name_kana
        })
        this.fetchLoading = false
      } catch (error) {
        // let dialog
        // if (error.data.error) dialog = error.data.error
        // else dialog = `エラーが発生しました<br>時間をおいてもう一度お試しください`
        // if (error.data.error) {
        //   this.$swal.fire({
        //     text: `${dialog}`
        //   }).then(() => {
        //     this.fetchLoading = false
        //   })
        // }
      }
    },
    toNote () {
      this.details.forEach(element => {
        const childName = element.family_name + element.given_name
        this.$router.push({
          name: 'ChildNote',
          params: { nurseryCode: this.$route.params.nurseryCode, nurseryName: this.$route.params.nurseryName, childId: this.$route.params.childId, childName: childName }
        })
      })
    },
    back () {
      this.details.forEach(element => {
        this.$router.push({
          name: 'ChildList',
          params: { nurseryCode: this.$route.params.nurseryCode, nurseryName: this.$route.params.nurseryName }
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../stylus/main.styl'
.container
  width 100vw
  height 100vh
  display flex
  flex-direction row
h6
  color $color-secondary
h5
  color $color-secondary
.flex
  display flex
.child-title
  margin 20px 10px
  width 200px
.child-detail
  margin 20px 10px
.col-group
  display flex
  flex-direction column
  margin 8px auto
.edit-card
  margin auto
  padding 30px
  display flex
  width 50vw
  flex-direction column
  background-color white
.edit-btn
  margin 40px auto
</style>



// WEBPACK FOOTER //
// src/views/ChildDetail.vue